import React, {Component} from 'react';
import {connect} from 'react-redux';
import { 
    Grid,
    Header,
    Segment,
    Item,
    Loader
} from 'semantic-ui-react';
import _ from 'underscore';
import qs from 'query-string';

import {
    getClinicLocatorList,
    updateClinicFilterOptions
} from '../../actions';
import ClinicList from '../../component/clinic/clinic_list';
import ClinicListFilter from '../../component/clinic/clinic_list_filter';
import ClinicListItem from '../../component/clinic/clinic_list_item';

class ClinicLocatorPage extends Component {
    state = {
        mode: 1, // 1 - browse, 2 - view one after search
        selectedClinicObjectKey: null
    }
    componentDidMount() {
        // if query param has items set those, if not reset filterOptions;
        const { search } = this.props.location;
        const companyId = this.props.filterOptions.filterByCompany ? this.props.filterOptions.filterByCompany : this.props.user.companies[0].companyId

        if (search) {
            const parsedQueryString = qs.parse(search);
            this.props.updateClinicFilterOptions({filterByType: parseInt(parsedQueryString.type), filterByArea: null});
            this.setState({mode: 3, selectedClinicObjectKey: null});
        } else {
            this.props.updateClinicFilterOptions({filterByType: null, filterByArea: null, filterByCompany: companyId});
        }

        this.props.getClinicLocatorList(this.props.user.accessToken, companyId);

    }
    componentDidUpdate(prevProps) {
        const { filterByCompany } = prevProps.filterOptions;
        if (filterByCompany !== this.props.filterOptions.filterByCompany) {
            this.props.getClinicLocatorList(this.props.user.accessToken, this.props.filterOptions.filterByCompany);
        }
    }
    updateMode(mode, selectedClinicObjectKey) {
        if (mode === 3) {
            this.setState({mode, selectedClinicObjectKey: null});
        }
        if (mode === 2) {
            this.props.updateClinicFilterOptions({filterByType: null, filterByArea: null});
            this.setState({mode, selectedClinicObjectKey});
        } else {
            // this.props.updateClinicFilterOptions({filterByType: null, filterByArea: null});
            this.setState({mode, selectedClinicObjectKey: null});
        }
    }
    render() {
        if (this.props.clinics.length === 0) {
            return <Loader active />
        }
        // console.log(this.props);
        // const clinicsToDisplay = (this.state.mode === 1) ? this.props.clinics : [this.props.clinics[this.state.selectedClinicObjectKey]];
        let clinicsToDisplay = this.props.clinics;
        if (this.state.mode === 2) {
            clinicsToDisplay = [this.props.clinics[this.state.selectedClinicObjectKey]]
        } else if (this.state.mode === 3) {
            // filter list based on type and area
            const {filterByType, filterByArea} = this.props.filterOptions;
            if (filterByType || filterByType === 0) {
                clinicsToDisplay = _.filter(clinicsToDisplay, (clinic) => clinic.t === filterByType);
            }
            if (filterByArea) {
                clinicsToDisplay = _.filter(clinicsToDisplay, (clinic) => clinic.ar === filterByArea);
            }
        }
        // console.log(clinicsToDisplay, this.state.selectedClinicObjectKey);
        return (
            <Grid>
                <Grid.Row>
                    <Grid.Column>
                        <Header as='h4' attached='top' block>
                            Find Panel Clinics
                        </Header>
                        <Segment attached>
                            <ClinicListFilter 
                                mode={this.state.mode}
                                clinics={this.props.clinics}
                                updateMode={this.updateMode.bind(this)}
                                typeList={this.props.typeList}
                                zoneList={this.props.zoneList}
                                areaList={this.props.areaList}
                                filterOptions={this.props.filterOptions}
                                updateClinicFilterOptions={this.props.updateClinicFilterOptions}
                                user={this.props.user}
                            />
                        </Segment>
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column>
                        {
                            (this.state.mode === 1) ? 
                            (
                                <ClinicList 
                                    clinics={clinicsToDisplay}
                                    mode={this.state.mode}
                                />
                            )
                            :
                            (this.state.mode === 2) ?
                            (
                                <Segment>
                                    <Item.Group divided>
                                        <ClinicListItem
                                            data={clinicsToDisplay[0]}
                                        />
                                    </Item.Group>
                                </Segment>
                            )
                            :
                            (
                                <ClinicList 
                                    clinics={clinicsToDisplay}
                                    mode={this.state.mode}
                                />
                            )
                        }
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

function mapStateToProps(state) {
    return { 
        user: state.user.user,
        clinics: state.clinics.data,
        typeList: state.clinics.typeList,
        zoneList: state.clinics.zoneList,
        areaList: state.clinics.areaList,
        filterOptions: state.clinics.filterOptions
    };
}

export default connect(mapStateToProps, {getClinicLocatorList,updateClinicFilterOptions})(ClinicLocatorPage);